import styles from './StepDots.module.css';

export function StepDots({
  total, current, onJump,
}: { total: number; current: number; onJump: (i: number) => void }) {
  return (
    <div className={styles.dots} role="tablist" aria-label="Прогресс обучения">
      {Array.from({ length: total }).map((_, i) => (
        <button
          key={i}
          role="tab"
          aria-selected={i === current}
          aria-label={`Шаг ${i + 1} из ${total}`}
          className={i === current ? styles.dotActive : styles.dot}
          onClick={() => onJump(i)}
        />
      ))}
    </div>
  );
}
